import { BookmarkClient } from "~/api/bookmark";
import type { IBookmark } from "~/models/ILegalTextParagraph";
import { pushUpdater, replaceUpdater } from "../mutationHelpers";

export const bookmarksMutations = () => {
  const queryClient = useQueryClient();
  const { bookmarks } = queries();
  const api = useApiClient(BookmarkClient);

  const createBookmarkMutation = useMutation({
    mutationFn: api.createBookmark,
    onSuccess: async (data) => {
      void queryClient.invalidateQueries({
        queryKey: bookmarks.tree.queryKey,
      });

      queryClient.setQueryData(bookmarks.all.queryKey, pushUpdater(data));
    },
  });

  const updateBookmarkMutation = useMutation({
    mutationFn: api.updateBookmark,
    onSuccess: async (data, variables) => {
      void queryClient.invalidateQueries({
        queryKey: bookmarks.tree.queryKey,
      });

      queryClient.setQueryData(
        bookmarks.all.queryKey,
        replaceUpdater(data, (bookmark) => bookmark.id === variables.id)
      );
    },
  });

  const deleteBookmarkMutation = useMutation({
    mutationFn: api.deleteBookmark,
    onSuccess: async (_, id) => {
      void queryClient.invalidateQueries({
        queryKey: bookmarks.tree.queryKey,
      });

      queryClient.setQueryData(
        bookmarks.all.queryKey,
        deleteUpdater<IBookmark>((bookmark) => bookmark.id === id)
      );
    },
  });

  return {
    createBookmarkMutation,
    updateBookmarkMutation,
    deleteBookmarkMutation,
  };
};
